
export default require('events').EventEmitter.prototype
